import React from 'react';
import { CircularProgress } from '@rmwc/circular-progress';
import styles from './ResultsLoadingState.module.css';

export const ResultsLoadingState: React.FC = () => (
  <div className="grid place-items-center place-content-center self-center">
    <CircularProgress className={styles.circularProgress} theme="secondary" size="xlarge" />
  </div>
);
